import { Header, LocalisedLink, SessionDetails, SessionDetailsSkeleton } from "@/components";
import routes from "@/constants/routes";
import { useGetVisitQuery } from "@/store/apis";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function SessionDetailsPage() {
  const { t, i18n } = useTranslation();
  const { visitId } = useParams();
  const { data: session, isLoading } = useGetVisitQuery({
    id: Number(visitId),
    lang: i18n.language,
  });

  return (
    <>
      <div className="hidden lg:block">
        <Header />
      </div>
      <div className="w-screen border-b border-veryLightGray p-5 lg:border-none lg:bg-backgroundApp lg:pl-32">
        <LocalisedLink
          to={routes.myVisits}
          className="flex items-center text-sm font-bold text-secondaryText hover:text-primaryText lg:text-base"
        >
          <ChevronLeft className="-ml-2" strokeWidth="1.2" />
          {t("sessionDetails.backToSessions")}
        </LocalisedLink>
      </div>
      <div className="min-h-screen space-y-4 bg-backgroundApp p-5 text-sm font-normal text-secondaryText lg:h-auto lg:px-56">
        {isLoading && <SessionDetailsSkeleton />}
        {session && <SessionDetails session={session} />}
      </div>
    </>
  );
}

export { SessionDetailsPage };
